import React, { ReactElement, useContext } from 'react'
import { useRecoilValue } from 'recoil'
import { loggedUserState } from '../../states/logged-user-state'
import { ACLRole } from '../../types/types'
import { EditModeContext } from '../../utils/edit-mode-context'

interface Props {
  onlyAdmin?: boolean
  onlyManagement?: boolean
  isEditableOnly?: boolean
  children: ReactElement | ReactElement[]
}

const Component = (props: Props): ReactElement | null => {
  const loggedUser = useRecoilValue(loggedUserState)
  const accessRole = loggedUser?.accessRole
  const { children, onlyAdmin, onlyManagement, isEditableOnly } = props

  const isEditable = useContext(EditModeContext)

  const isAdmin = accessRole?.codename === ACLRole.ADMIN
  const isManagement = accessRole?.codename === ACLRole.MANAGEMENT

  if (isEditableOnly && !isEditable) {
    return null
  }

  if (isAdmin) {
    // Show everything for admin
    return <>{children}</>
  }

  if (!isAdmin && onlyAdmin) {
    return null
  }

  if (!isManagement && onlyManagement) {
    return null
  }

  return <>{children}</>
}

export const ACLContainer = React.memo(Component)